import { render, staticRenderFns } from "./Remanufactura.vue?vue&type=template&id=0394b74f&"
import script from "./Remanufactura.vue?vue&type=script&lang=js&"
export * from "./Remanufactura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports